<mat-card-content>
  <div id="containerGanancia"></div>
  <div class="center-container">
    <small class="subitutlo-simpli">
      Con <span class="color-simpli">Simpli</span> obtienes &#8594;
      <span class="color-monto">${{ montoGanancia | formatting:'money' }} </span>
      <span class="color-monto">({{ porcentajeGanancia }}%) </span>más que un DAP en esta inversión.
    </small>
  </div>
</mat-card-content>